module.exports = __webpack_public_path__ + "static/img/dark-warin.034fadf9.png";